import React, { useState, useEffect } from 'react';
import { ExternalLink, MessageCircle, X } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
import { CONFIG } from '../data/villaData';

export default function BookingSidebar({ onBookClick }) {
  const { t } = useLanguage();
  const [collapsed, setCollapsed] = useState(false);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 400);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!show) return null;

  return (
    <div className={`fixed right-0 top-1/2 -translate-y-1/2 z-40 transition-transform duration-500 ${collapsed ? 'translate-x-[calc(100%-48px)]' : ''}`}>
      <div className="flex items-stretch">
        <button
          onClick={() => setCollapsed(!collapsed)}
          className="bg-[#b8945e] hover:bg-[#a07d4a] text-white px-2 py-6 rounded-l-xl shadow-lg flex items-center"
          aria-label="toggle"
        >
          {collapsed ? (
            <span className="writing-vertical text-xs font-semibold tracking-widest uppercase" style={{ writingMode: 'vertical-rl' }}>
              {t.booking.sideTitle}
            </span>
          ) : (
            <X size={18} />
          )}
        </button>

        <div className="bg-white shadow-2xl rounded-l-2xl p-5 w-72 border-l-4 border-[#b8945e]">
          <h4 className="font-serif text-lg text-stone-900 mb-1">{t.booking.sideTitle}</h4>
          <p className="text-xs text-stone-500 mb-4">{t.booking.sideText}</p>

          <button
            onClick={onBookClick}
            className="w-full mb-2 px-4 py-3 bg-[#25D366] hover:bg-[#1ebe5b] text-white text-sm font-semibold rounded-xl flex items-center justify-center gap-2 transition-colors shadow-md"
          >
            <MessageCircle size={16} />
            WhatsApp
          </button>

          <a
            href={CONFIG.bookingUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full px-4 py-3 bg-[#003580] hover:bg-[#002650] text-white text-sm font-semibold rounded-xl flex items-center justify-center gap-2 transition-colors"
          >
            Booking.com
            <ExternalLink size={14} />
          </a>

          <div className="mt-4 pt-4 border-t border-stone-100 text-center">
            <p className="text-xs text-stone-500">{CONFIG.whatsappDisplay}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
